import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  LinearProgress,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";
import CustomMenuList from "../../customComponents/CustomMenuList";
import { useGetClassesQuery } from "../classroom/classApiSlice";
import { useGetAssessmentsQuery } from "../settings/assessments/assessmentsApiSlice";
import { useGetTeacherSubjectsQuery } from "../staff/staffApiSlice";
import ScoreSheet from "./ScoreSheet";

const CAManager = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [activeSubject, setActiveSubject] = useState(0);
  const [activeAssessment, setActiveAssessment] = useState(0);
  const [openSubjects, setOpenSubjects] = useState(true);
  const [openAssessments, setOpenAssessments] = useState(false);
  const { data: mySubjects, isLoading: loadingMySubjects } =
    useGetTeacherSubjectsQuery();
  const activeSubsectionId = mySubjects?.[activeSubject]?.subsection_id;
  const { data: assessments, isLoading: loadingAssessments } =
    useGetAssessmentsQuery(`all/${activeSubsectionId}`, {
      skip: !activeSubsectionId,
    });
  const { data: classrooms } = useGetClassesQuery("all");

  const subjectsMenu = mySubjects?.map(
    (subject) =>
      `${subject.name}: ${
        classrooms?.find((item) => subject?.classroom_id === item.id)?.name
      }`
  );

  const subSectionAssessments = assessments || [];

  const assessmentsMenu = subSectionAssessments?.map(
    (assessment) => assessment.name
  );

  const handleSubjectChange = (index) => {
    setActiveSubject(index);
    setActiveAssessment(0);
    if (isMobile) {
      setOpenSubjects(false);
      setOpenAssessments(true);
    }
  };

  const handleAssessmentChange = (index) => {
    setActiveAssessment(index);
    if (isMobile) {
      setOpenAssessments(false);
    }
  };

  return (
    <>
      <Grid container columnSpacing={3}>
        <Grid item xs={12} md={4} lg={3}>
          {isMobile ? (
            <Accordion
              expanded={openSubjects}
              onChange={(_, expanded) => setOpenSubjects(expanded)}
              disableGutters
              sx={{ mb: 1 }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>Subjects</Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ p: 0 }}>
                {loadingMySubjects && <LinearProgress />}
                <CustomMenuList
                  activeTab={activeSubject}
                  setActiveTab={handleSubjectChange}
                  heading="Subjects"
                  list={subjectsMenu || []}
                  icon={
                    <img
                      src={require(`../../../assets/images/books.png`)}
                      alt="subject"
                      height={25}
                      width={25}
                    />
                  }
                />
              </AccordionDetails>
            </Accordion>
          ) : (
            <>
              {loadingMySubjects && <LinearProgress />}
              <CustomMenuList
                activeTab={activeSubject}
                setActiveTab={handleSubjectChange}
                heading="Subjects"
                list={subjectsMenu || []}
                icon={
                  <img
                    src={require(`../../../assets/images/books.png`)}
                    alt="subject"
                    height={25}
                    width={25}
                  />
                }
              />
            </>
          )}
        </Grid>
        <Grid item xs={12} md={4} lg={3}>
          {isMobile ? (
            <Accordion
              expanded={openAssessments}
              onChange={(_, expanded) => setOpenAssessments(expanded)}
              disableGutters
              sx={{ mb: 1 }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>Assessment(s)</Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ p: 0 }}>
                {loadingAssessments && <LinearProgress />}
                <CustomMenuList
                  activeTab={activeAssessment}
                  setActiveTab={handleAssessmentChange}
                  heading="Assessment(s)"
                  list={assessmentsMenu || []}
                  icon={
                    <img
                      src={require(`../../../assets/images/assessment.png`)}
                      alt="subject"
                      height={20}
                      width={20}
                    />
                  }
                />
              </AccordionDetails>
            </Accordion>
          ) : (
            <>
              {loadingAssessments && <LinearProgress />}
              <CustomMenuList
                activeTab={activeAssessment}
                setActiveTab={handleAssessmentChange}
                heading="Assessment(s)"
                list={assessmentsMenu || []}
                icon={
                  <img
                    src={require(`../../../assets/images/assessment.png`)}
                    alt="subject"
                    height={20}
                    width={20}
                  />
                }
              />
            </>
          )}
        </Grid>
        <Grid item xs={12} md={4} lg={6}>
          <ScoreSheet
            mySubjects={mySubjects || []}
            activeSubject={activeSubject}
            myAssessments={subSectionAssessments || []}
            activeAssessment={activeAssessment}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default CAManager;
